import {
    saveEmailSignUpData,
    signUpForEmailError
} from '../actions/helpActions';

import template from 'emailsignup.j2';
import {
    checkForm,
    buildErrorsFromMsgs
} from '../../../core/js/utils/errorHandling';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

/**
 * Attach component events to DOM
 * @param {Object} store - current state
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-anonymous-email-signup-form'), (event) => {
        event.preventDefault();
        const formData = {};
        const emailInput = $(`${this.templateLocation} .js-email-signup-email-address`);

        formData.emailAddress = emailInput.val();
        formData.gender = $(this.scopedSelector('.js-email-signup-gender', '.js-anonymous-email-signup-form input:hidden[name=gender]')).val() || 'U';
        formData.source = $(this.scopedSelector('input:hidden[name=email-signup-subscription-source]')).val();

        store.dispatch(saveEmailSignUpData(formData));
    });
}

/**
* Bootstrap the component onto the page
* @param {Object} component - config context
* @param {Object} store - current state
* @returns {undefined}
*/
function activateParsley(component, store) {
    $(component.scopedSelector('.js-anonymous-email-signup-form')).parsley().on('field:error', () => {
        const msgs = checkForm(component.scopedSelector('.js-anonymous-email-signup-form'));
        const convertedMsgs = buildErrorsFromMsgs(msgs[1]);

        store.dispatch(signUpForEmailError(convertedMsgs));
    });
}

/**
* Bootstrap the component onto the page
* @param {Object} store - current state
* @returns {undefined}
*/
function afterConstruction(store) {
    this.render(store, this, {});
    activateParsley(this, store);
}

/**
* Bootstrap the component onto the page
* @param {Object} store - current state
* @param {Object} overrides - config overrides
* @returns {undefined}
*/
export function init(store, overrides = {}) {
    const config = {
        name: 'helpEmailSignUpComponent',
        attachEvents: attachEvents,
        isComponentValid: templateLocationExists,
        watch: 'help.emailSignUp',
        replace: false,
        template: template,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        templateLocation: '.dom-anonymous-email-signup',
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides);
}
